<style lang="less">
.Acctplus_detail{
	.head{
		padding: 0 17px;
		border-bottom: 12px solid #f2f2f2;
		.cont{
			display: -webkit-box; display:flex;
			-webkit-box-align: center; align-items: center;
			padding-top: 36px;
			h1{
				font-size: 36px;
				height: 36px;
				width: 170px;
				color: #dc2a2a;
				font-weight: 400;
			}
			.info{
				-webkit-box-flex: 1; -moz-box-flex: 1; -ms-flex: 1; flex: 1;
				text-align: right;
				h3{
					display: inline-block;
					font-size: 16px;
					line-height: 20px;
					height: 18px;
					width: 105px;
					color: #2e4276;
					font-weight: 500;
					text-align: right;
				}
				p{
					margin-top: 20px;
				}
			}
		}
		.desc{
			display: -webkit-box; display:flex;
			-webkit-box-align: center; align-items: center;
			padding-bottom: 24px;
			.info{
				-webkit-box-flex: 1; -moz-box-flex: 1; -ms-flex: 1; flex: 1;
			}
			p{
				font-size: 14px;
				color: #999;
				margin-top: 4px;
			}
		}
		.head_foot{
			border-top: 1px solid #e5e5e5;
			height: 36px;
			display: -webkit-box; display:flex;
			-webkit-box-align: center; align-items: center;
			font-size: 12px;
			.feature{
				-webkit-box-flex: 1; -moz-box-flex: 1; -ms-flex: 1; flex: 1;
				color: #2e4276;
				font-weight: 400;
			}
			.support{
				color: #999;
			}
		}
	}
	.char{
		border-bottom: 12px solid #f2f2f2;
	}
	.point{
		h3{
			font-size: 14px;
			font-weight: 500;
			padding: 17px 2px 15px 17px;
		}
		border-bottom: 12px solid #f2f2f2;
	}
	.rule{
		padding: 6px;
		border-bottom: 12px solid #f2f2f2;
		h2{
			font-size: 14px;
			font-weight: 500;
			padding: 6px 0 0 17px;
		}
		.cont{
			font-size: 12px;
			padding: 10px 17px;
			.item{
				display: -webkit-box; display:flex;
				padding: 5px 0;
				line-height: 18px;
				h3{
					width: 58px;
					padding-right: 18px;
					text-align: right;
					-webkit-box-flex: 0 0 auto; -moz-box-flex: 0 0 auto; -ms-flex: 0 0 auto; flex: 0 0 auto;
					font-weight: 500;
				}
				p{
					-webkit-box-flex: 1; -moz-box-flex: 1; -ms-flex: 1; flex: 1;
					color: #999;
				}
			}
		}
	}
	.detail_agreement{
		padding: 8px;
		.vue-item{
			&:before{
				content: '';
				display: none;
			}
		}
	}
}
</style>

<template>
	<!-- Main Acctplus_detail -->
	<section class="Acctplus_detail">
		<div class="head">
			<div class="cont">
				<h1>{{product.rate}}%</h1>
				<div class="info">
					<h3>随买随取</h3>
				</div>
			</div>
			<div class="desc">
				<p class="info">近七日年化收益率</p>
				<p>理财期限</p>
			</div>
			<div class="head_foot">
				<div class="feature">一分起购，收益稳健</div>
				<div class="support">本产品由广发银行提供</div>
			</div>
		</div>

		<div class="char">
			<div class="title">
				<h3>近七日年化收益率</h3>
				<p>万份收益：{{product.exp_per_profit}}元</p>
			</div>
			<div class="cont">
				<char :charData="product.history"></char>
			</div>
		</div>

		<div class="point">
			<h3>产品亮点</h3>
			<div class="cont">
				<point></point>
			</div>
		</div>

		<div class="rule">
			<h2>交易规则</h2>
			<div class="cont">
				<div class="item">
					<h3>买入</h3>
					<p>随时可买</p>
				</div>
				<div class="item">
					<h3>收益</h3>
					<p>现在买入，{{expDate.val}}产生收益，{{expDate.rec}}第一笔收益到账</p>
				</div>
				<div class="item">
					<h3>快速取出</h3>
					<p>随时可取，每日限额 {{product.quick_redeem_amt}} 元</p>
				</div>
				<div class="item">
					<h3>普通取出</h3>
					<p>随时可取，不限额度，T+1日到账</p>
				</div>
			</div>
		</div>

		<div class="detail_agreement">
			<item
				mark-subject="服务协议"
				submark-subject-attach="国寿安保鑫钱包货币服务协议"
				ico-type="next"
				@click.native="next">
			</item>
		</div>

	</section>
</template>

<script>
	import item from '@flyme/jr/flyme7/component/item/vue-item.vue';
	import android from '@flyme/jr/js/android.js';

	import char from '../components/char_2.vue';
	import point from '../components/point.vue';

	import axios from '../axios.js';
	import apis from '../apis.js';

	export default {
		data: function () {
			return {
				product: {
					history: {}
				},
				expDate: {
					val: '',
					rec: ''
				},
			};
		},
		components: {
			item,
			char,
			point
		},
		mounted: function () {
			android('setTitle', {
				title:"国寿安保鑫钱包货币"
			});
			this.getProduct();
			this.getExpDate();
		},
		methods: {
			getProduct: function () {
				let _this = this;
				axios.post(apis.acctplus_product_query, {
					show_type: 1
				}).then(function(d) {
					console.log('acctplus_product_query', d, d.value.history_rates);
					if (d.value) {
						d.value.history = {};
						_this.product = d.value;
						_this.getCharData();
					}
				});
			},
			getCharData: function () {
				var data = this.product.history_rates;
				var charData = {
					x: [],
					y: []
				};
				for( var i = data.length - 1; i >= 0; i--){
					charData.x.push(new Date(data[i].date).Format("MM/dd"));
					charData.y.push(data[i].rate);
				}
				console.log(charData);
				this.product.history = charData;
			},
			getExpDate: function () {
				let _this = this;
				axios.post(apis.product_expected_date, {}).then(function(d) {
					console.log('product_expected_date', d);
					_this.expDate.val = new Date(parseInt(d.value.value_date)).Format("MM 月 dd 日");
					_this.expDate.rec = new Date(parseInt(d.value.rec_value_date)).Format(" MM 月 dd 日");
				});
			},
			next: function () {
				// var id = "1530173772017"; //测试环境
				var id = "1530172771558";	//外网
				android('startPage', {
					url: 'https://wallet.mzres.com/static/richtext/index.html?show_padding=1&id=' + id,
					start_type:1,
					data:'',
					display:{
						title: '国寿安保鑫钱包货币服务协议'
					}
				});
			}
		}
	};
</script>


// WEBPACK FOOTER //
// src/pages/Acctplus_detail.vue